import React, { useState, useRef, useEffect } from 'react';
import { _T, C } from '../../shared/theme';
import { s_GB } from '../../shared/styles';
import { saveAvatarImage } from '../../shared/dbService';

function AvatarUploader({userId, userName, accentColor, size=56, onImageChange}) {
  const [img, setImg] = useState(null);
  const fileRef = useRef(null);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(`sl_avatar_${userId||userName}`);
      if (stored) { setImg(stored); return; }
      // Fall back to Google profile picture if no uploaded avatar
      const gPic = localStorage.getItem('sl_google_picture');
      if (gPic) setImg(gPic);
    } catch {}
  }, [userId, userName]);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 2 * 1024 * 1024) { alert("Image too large. Please choose an image under 2MB."); return; }
    const reader = new FileReader();
    reader.onload = (ev) => {
      const b64 = ev.target.result;
      setImg(b64);
      try { localStorage.setItem(`sl_avatar_${userId||userName}`, b64); } catch {}
      saveAvatarImage(b64);
      onImageChange && onImageChange(b64);
    };
    reader.readAsDataURL(file);
  };

  const removeImg = () => {
    setImg(null);
    try { localStorage.removeItem(`sl_avatar_${userId||userName}`); } catch {}
    saveAvatarImage(null);
    onImageChange && onImageChange(null);
  };

  return (
    <div style={{position:"relative",display:"inline-block"}}>
      {img ? (
        <div style={{width:size,height:size,borderRadius:"50%",overflow:"hidden",border:`3px solid ${accentColor}`,cursor:"pointer"}} onClick={()=>fileRef.current?.click()}>
          <img src={img} alt="avatar" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
        </div>
      ) : (
        <div onClick={()=>fileRef.current?.click()} style={{width:size,height:size,borderRadius:"50%",background:`linear-gradient(135deg,${accentColor}44,${accentColor}22)`,border:`3px solid ${accentColor}55`,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",cursor:"pointer",gap:2}}>
          <span style={{fontSize:18}}>📷</span>
          <span style={{fontSize:8,color:accentColor,fontWeight:600}}>UPLOAD</span>
        </div>
      )}
      {/* Small edit badge */}
      <div onClick={()=>fileRef.current?.click()} style={{position:"absolute",bottom:0,right:0,width:20,height:20,borderRadius:"50%",background:`linear-gradient(135deg,${_T.grad1},${_T.grad2})`,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:13,border:`2px solid ${_T.bg}`}}>✏️</div>
      {img && (
        <div onClick={removeImg} style={{position:"absolute",top:-4,right:-4,width:18,height:18,borderRadius:"50%",background:C.red,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",fontSize:9,color:"white",border:`2px solid ${_T.bg}`,fontWeight:700}}>✕</div>
      )}
      <input ref={fileRef} type="file" accept="image/*" style={{display:"none"}} onChange={handleFile}/>
    </div>
  );
}

export default AvatarUploader;
